module.exports = __webpack_public_path__ + "static/media/intro-cloud-large.e6ae65c7.svg";